import React, { useState, useEffect } from 'react';
import CommonComponent from "../../CommonComponent"
import { useTranslation } from 'react-i18next';
import FulfillmentChart from './ChartLayout/FulfillmentChart';
import RegionalShareChart from './ChartLayout/RegionalShareChart';
import EliteWarehouseChart from './ChartLayout/EliteWarehouseChart';
import useGeographicalSalesInsights from './useGeographicalSalesInsights'
import usePersistentDateRange from '../../Common/usePersistentDateRange';
import NormalTable from '../../../../utility/table/NormalTable.jsx';
import NoDataFound from '../NoDataFound/NoDataFound'
import Spinner from '../NoDataFound/Spinner'
import DashboardReady from '../DashboardReady/DashboardReady'
import categorySelectionDynamic from '../../Common/categorySelectionDynamic';
import AllowedCard from '../../../../common/AllowedCard.jsx';


const GeographicalSalesInsights = ()=> {
  const {
    loading,
    fulfillmentChannelState,
    regionalShareState,
    eliteWarehouseState,
    getFulfillmentChannel,
    getRegionalShare,
    getEliteWarehouse,
    geographicalSalesState,
    getGeographicalSales,geographicalSalesSequence,accessDenied
  } = useGeographicalSalesInsights();
  const { t } = useTranslation();


  const {
    selectedRange,
    handleDateChange,
    formattedStart,
    formattedEnd,
  } = usePersistentDateRange();

  const {
    categoryId,
    categoryName,
    handleCategoryClick,
    onBreadcrumbClick
  } = categorySelectionDynamic([getFulfillmentChannel, getRegionalShare, getEliteWarehouse, getGeographicalSales], formattedStart, formattedEnd);

  useEffect(() => {
    getFulfillmentChannel({ formattedEnd, formattedStart });
    getRegionalShare({ formattedEnd, formattedStart });
    getEliteWarehouse({ formattedEnd, formattedStart });
    getGeographicalSales({ formattedEnd, formattedStart });
  }, [formattedStart, formattedEnd]);

  const [selectedIds, setSelectedIds] = useState({
    productId: [],
    categoryId: []
  });
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);


  useEffect(() => {
    setIsButtonDisabled(false); // Re-enable when user changes selection
  }, [selectedIds]);

  const handleSelectionChange = (ids) => {
    const hasNoSelection =
      ids.productId.length === 0 && ids.categoryId.length === 0;

    if ((selectedIds.productId.length + selectedIds.categoryId.length > 0 )&& hasNoSelection) {
      window.location.reload();
    }

    setSelectedIds(ids);
  };

  const handleReflectSelection = (e) => {
    e.preventDefault(); // prevents default button behavior
    setIsButtonDisabled(true);
    getEliteWarehouse({ formattedEnd, formattedStart, selectedIds });
    getRegionalShare({ formattedEnd, formattedStart, selectedIds });
    getFulfillmentChannel({ formattedEnd, formattedStart, selectedIds });
  };
  const dashboardReady = localStorage.getItem('dashboard-ready') === 'true';
  const geographicalSalesStateEmpty = !geographicalSalesState || Object.keys(geographicalSalesState).length === 0;
  if (accessDenied){
    return(
      <div className='d-flex justify-content-center' style={{ textAlign: "center", padding: "30px", fontWeight: "500" }}>
      <AllowedCard/>
      </div>
    )
  }
  return (
    <>
      <CommonComponent
        defaultRange={selectedRange}
        onRangeChange={handleDateChange}
        categoryName={categoryName}
        categoryId={categoryId}
        onBreadcrumbClick={onBreadcrumbClick}
      />
      {!dashboardReady ?  <DashboardReady /> :
        <section className="section dashboard py-2">
          <div className="row m-0">
            <div className="col-12">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="card">
                    <div className="filter"></div>
                    <div className="card-body">
                      <h5 className="card-title">{t("geographicalSalesInsights.fullfillmentChannel")}</h5>
                      {loading ? (
                        <Spinner height={300} />
                      ) : (
                      <FulfillmentChart chartData={fulfillmentChannelState} />
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="card">
                    <div className="card-body d-flex flex-column">
                      <h5 className="card-title mb-3">{t("geographicalSalesInsights.regionalShare")}</h5>
                      <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                        {/* Limit height and maintain responsiveness */}
                        <div style={{ width: "100%", maxWidth: "300px", height: "auto" }}>
                        {loading ? (
                          <Spinner height={300} />
                        ) : (
                            <RegionalShareChart chartData={regionalShareState} />
                        )}    
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="card">
                    <div className="filter"></div>
                    <div className="card-body">
                      <h5 className="card-title">{t("geographicalSalesInsights.eliteWarehouse")}</h5>
                      {loading ? (
                        <Spinner height={300} />
                      ) : (
                        <EliteWarehouseChart chartData={eliteWarehouseState} />
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="card">
                    <div className="card-body h-auto">
                      <div className="justify-content-between align-items-baseline">
                        <div className="d-flex justify-content-between align-items-baseline">
                          <h5 className="card-title">{t("geographicalSalesInsights.geographicalSales")}</h5>
                        </div>
                        {
                      !loading && Array.isArray(geographicalSalesState) && geographicalSalesState.length === 0 ? (
                      <div className='d-flex justify-content-center' style={{ textAlign: "center", padding: "30px", fontWeight: "500" }}>
                        No data found for the given criteria.
                      </div>
                      ) : (
                        <NormalTable
                          tableId="geographicalSalesID"
                          data={geographicalSalesState}
                          selectedIds={selectedIds}
                          onSelectionChange={handleSelectionChange}
                          prioritizeSelected={isButtonDisabled}
                          onCategoryClick={handleCategoryClick}
                          loading={loading}
                          sequence={geographicalSalesSequence}
                        />)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      }
      {(selectedIds.productId.length + selectedIds.categoryId.length > 0) && (
        <button
          className="floating-btn-select"
          onClick={handleReflectSelection}
          disabled={isButtonDisabled}
        >
          ({selectedIds.productId.length + selectedIds.categoryId.length}) {t("checkboxSelect.heading")}
        </button>
      )}
    </>
  );
}


export default GeographicalSalesInsights;